import React, { useEffect, useState } from "react";
import { useGetPalletsQuery } from "../../../app/globalApi";
import { useGetRipeningRoomByIdQuery } from "./ripeningApi";
import Datatable from "../../../components/shared/datatable/Datatable";
import Button from "../../../components/shared/buttons/button";
import RoomByIdModal from "./RoomByIdModal";
import { PlusSvg } from "../../../svgFiles/PlusSvg";
import DateSelector from "../../../components/shared/fields/DateSelector";
import GridCard from "../../../components/shared/gridCard/GridCard";
import { useGetRipeningSummaryQuery } from "../dashboard/ripeingDashboardApi";
import KgEntered from "../../../images/material_kg.svg";
import TotalCase from "../../../images/totalCase.svg";
import TotalCapacity from "../../../images/room_capacity.svg";
import RipeningOverViewModal from "../overview/RipeningOverViewModal";
import { formatDateTime } from "../../../components/shared/utils";
import useTranslator from "../../../hooks/useTranslator";
import { convertToUserTimezone, formatDateAndTime, formatPalletName, getCurrentDate, normalizePalletCodeFilter, parsePalletCodeFilter , getTranslatedRoomName } from "../../../helpers/Utils";
import { DEFAULT_DATE_FORMAT, PROJECT_DATE_FORMAT } from "../../../helpers/constants";

const RoomById = ({ room, setShow }) => {
  const { _t } = useTranslator();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [addRoomCases, setAddRoomCases] = useState(false);
  const [showOverviewModal, setShowOverviewModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [roomId, setRoomId] = useState(room.id);
  const [selectedCase, setSelectedCase] = useState(null);
  const [modalMode, setModalMode] = useState("add");
  const currentDate = getCurrentDate("YYYY-MM-DD");
  const [date, setDate] = useState(currentDate);
  const [tab, setTab] = useState("ripeningRoom");
  const [filter, setFilter] = useState({});
  const [appliedFilters, setAppliedFilters] = useState({
    entered_date: "",
    pallet_code: "",
  });

  const handleFilterApply = (newFilters) => {
    const normalizedPalletCode = normalizePalletCodeFilter(newFilters.pallet_code);
    const nextAppliedFilters = {
      ...newFilters,
      pallet_code: normalizedPalletCode,
    };

    setAppliedFilters(nextAppliedFilters);
    setFilter({
      ...newFilters,
      pallet_code: parsePalletCodeFilter(normalizedPalletCode),
    });
  };

  const [mergeRecords, setMergeRecords] = useState({
    data: [],
  });
  const { data: summaryData } = useGetRipeningSummaryQuery(
    {
      tab,
      room_id: roomId,
    },
    { refetchOnMountOrArgChange: true }
  );
  const { data: pallets } = useGetPalletsQuery();

  const { data: roomDetails, isFetching  ,isLoading } = useGetRipeningRoomByIdQuery(
    {
      page,
      pageSize,
      roomId,
      ...filter
    },
    { refetchOnMountOrArgChange: true }
  );

  const palletOptions = Array.from(
    new Map(
      (pallets?.data || [])
        .filter((item) => item?.id !== null && item?.id !== undefined && item?.id !== "")
        .map((item) => {
          const formattedCode = normalizePalletCodeFilter(item.pallet_name) || formatPalletName(item.id);
          return [formattedCode, { value: formattedCode, label: formattedCode }];
        })
    ).values()
  );

  

  const handlePageChange = (page) => {
    setPage(page);
  };
  const listItems = [
    {
      label: _t("total_capacity", "Total Capacity of Room"),
      value: summaryData?.data.total_room_capacity,
      icon: TotalCapacity,
    },
    {
      label: _t("available_total_capacity", "Available Capacity of Room"),
      value:
        summaryData?.data.total_room_capacity -
          (summaryData?.data.total_cases_entered || 0) || 0,
      icon: TotalCapacity,
    },
    {
      label: _t("kg_entered", "KG Entered"),
      value: summaryData?.data.total_kg_entered,
      icon: KgEntered,
    },
    {
      label: _t("cases_entered", "Cases Entered"),
      value: summaryData?.data.total_cases_entered,
      icon: TotalCase,
    },
    {
      label: _t("total_kg_moved", "Total kg Moved"),
      value: summaryData?.data.total_kg_moved,
      icon: TotalCase,
    },
    {
      label: _t("total_kg_evaporated", "Total kg Evaporated"),
      value: summaryData?.data.total_kg_evaporated,
      icon: TotalCase,
    },
  ];
  const handleClick = () => {
    setShow(false);
  };
  const handleAddRoomCases = () => {
    setAddRoomCases(true);
    setModalMode("add");
    setSelectedCase(null);
    setShowModal(true);
  };
  const handleView = (roomCase) => {
    setShowOverviewModal(true);
    setSelectedCase(roomCase);
  };
  const handleEdit = (roomCase) => {
    setAddRoomCases(true);
    setModalMode("edit");
    setSelectedCase(roomCase);
    setShowModal(true);
  };
  const handleEditSorting = (roomCase) => {
    
    setAddRoomCases(true);
    setModalMode("moved");
    setSelectedCase(roomCase);
    setShowModal(true);
  };
  const columns = [
    {
      label: _t("date_entered", "Date Entered"),
      accessor: "exit_date_time_to_ripening",
      cell: ({ value }) => convertToUserTimezone(value),
    },
    {
      label: _t("expected_done_ripening", "Expected Done Ripening"),
      accessor: "expected_date_to_exit",
      cell: ({ value }) => convertToUserTimezone(value,"DD-MM-YYYY")
    },
    { label: _t("pallet_code", "Pallet Code"), accessor: "pallet_code", cell: ({ value }) => formatPalletName(value) },

    { label: _t("case_entered", "Case Entered"), accessor: "case_entered" },
    {
      label: _t("weight_entered", "Weight Entered"),
      accessor: "fruit_entered_in_kg",
    },
    {
      label: _t("weight_after_ripening", "Weight After Ripening"),
      accessor: "weight_after_ripening",
    },
    {
      label: _t("exit_date", "Exit Date"),
      accessor: "exit_date_time",
      cell: ({ value }) => value ? convertToUserTimezone(value) : '---',
    },
    {
      label: _t("status", "Status"),
      accessor: "status",
      cell: ({ value }) => (
        <span
          className={
            value === "ripening"
              ? "cmn_badge inactive"
              : value === "sorting"
              ? "cmn_badge"
              : "cmn_badge rejected"
          }
        >
          {value === "ripening"
            ? _t("ripening", "Ripening")
            : value === "sorting"
            ? _t("ready_for_sorting", "Ready For Sorting")
            : _t("moved", "Moved")}
        </span>
      ),
    },

    {
      label: _t("overview", "Overview"),
      accessor: "status",
      cell: ({ row }) => (
        <>
          {isFetching && _t("loading", "Loading")}
          {!isFetching && (
            <Button
              size="small"
              label={
                row.status === "moved" ? _t("view", "View") : _t("edit", "Edit")
              }
              className={row.status === "moved" ? "borderRedBtn" : ""}
              onClick={
                row.status === "ripening"
                  ? () => handleEdit(row)
                  : row.status === "sorting"
                  ? () => handleEditSorting(row)
                  : () => handleView(row)
              }
            />
          )}
        </>
      ),
    },
  ];

  // console.log(`addRoomCases ${addRoomCases} | showOverviewModal : ${showOverviewModal} `)
  return (
    <div>
      {addRoomCases && (
        <RoomByIdModal
          show={showModal}
          setShow={setAddRoomCases}
          mode={modalMode}
          roomCase={selectedCase}
          room={room}
        />
      )}
      {showOverviewModal && (
        <RipeningOverViewModal
          show={showOverviewModal}
          setShow={setShowOverviewModal}
          record={selectedCase}
          mode="ripening-room"
        />
      )}
      <div className="breadcrumbs d-flex">
        <p onClick={handleClick}>
          {_t("ripening_room_logs", "Ripening Room Logs")} /{" "}
        </p>{" "}
        <span>
          <p className="current">{_t("room_log", "Room Log")}</p>
        </span>
      </div>
      <div className="overview cmn_card mb-3">
        <div className="overview_header d-flex gap-2 align-items-center">
          <h6 className="mb-0 flex-grow-1">
            {" "}
            {_t("ripening_rooms_overview", "Ripening Rooms Overview")}
          </h6>
          {/* <DateSelector setDate={setDate} /> */}
        </div>
        <ul className="m-0 grid_card_wrapper">
          {listItems.map((list, index) => (
            <GridCard
              key={index}
              title={list.label}
              value={list.value}
              icon={list.icon}
              day={currentDate === date ? _t("today", "Today") : formatDateAndTime(date,PROJECT_DATE_FORMAT)}
            />
          ))}
        </ul>
      </div>      
      
      <Datatable
        title={getTranslatedRoomName(room?.name , _t)}
        columns={columns}
        tableData={roomDetails?.data}        
        pagination
        page={page}
        onPageChange={handlePageChange}
        showFilter={handleFilterApply}
        showFilterButton={true}
        filterModule="ripening-room-by-id"
        filters={appliedFilters}
        filterProps={{ palletOptions }}
        isLoading={isFetching || isLoading}
      />      
    </div>
  );
};

export default RoomById;
